export default __webpack_public_path__ + "static/media/timeOutAudio.4f37c045.mp3";